import React, { useEffect, useState } from "react";
import { MousePointerClick, Phone, MessageSquareText } from "lucide-react";
import { api } from "../../lib/api";
import { WhatsAppLogo } from "../../components/home/ContactStrip";

const COLS = [["whatsapp", "WhatsApp", "#25D366"], ["call", "Call", "#0f2e2a"], ["text", "Text", "#2563eb"]];
const ICON = { whatsapp: <WhatsAppLogo size={18} />, call: <Phone size={17} />, text: <MessageSquareText size={17} /> };
const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });

export const ContactClicksCard = () => {
  const [days, setDays] = useState(14);
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/admin/contact-clicks?days=${days}`).then(({ data }) => setData(data)).catch(() => setData({ days: [], totals: {} })); }, [days]);
  const today = data?.days?.[0];
  const max = Math.max(1, ...(data?.days || []).map((r) => r.whatsapp + r.call + r.text));
  return (
    <div className="mt-6 rounded-2xl border border-[#e3f0ed] bg-white p-6" data-testid="contact-clicks-card">
      <div className="flex flex-wrap items-center gap-3">
        <MousePointerClick size={18} className="text-[#0e8c7f]" />
        <h3 className="text-[18px] font-bold text-[#0f2e2a]">WhatsApp, Call & Text taps</h3>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="ml-auto rounded-lg border border-[#dcebe8] px-2 py-1.5 text-[13.5px]" data-testid="contact-clicks-range">
          <option value={7}>Last 7 days</option><option value={14}>Last 14 days</option><option value={30}>Last 30 days</option>
        </select>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        {COLS.map(([k, l, c]) => (
          <div key={k} className="flex items-center gap-3 rounded-xl p-4 text-white" style={{ background: c }} data-testid={`contact-clicks-total-${k}`}>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">{ICON[k]}</span>
            <div><div className="text-[26px] font-extrabold leading-none">{data?.totals?.[k] ?? "–"}</div><div className="text-[12.5px] font-semibold text-white/85">{l} · today {today?.[k] ?? 0}</div></div>
          </div>
        ))}
      </div>
      <div className="mt-5 overflow-x-auto">
        <table className="w-full text-[14px]" data-testid="contact-clicks-table">
          <thead><tr className="text-left text-[12px] uppercase tracking-wide text-[#6b7c79]"><th className="py-2">Day</th>{COLS.map(([k, l]) => <th key={k} className="py-2 pl-2 text-right">{l}</th>)}<th className="hidden py-2 text-right sm:table-cell">Visitors</th><th className="hidden w-[30%] py-2 pl-4 sm:table-cell" /></tr></thead>
          <tbody>
            {(data?.days || []).map((r) => {
              const tot = r.whatsapp + r.call + r.text;
              return (
                <tr key={r.day} className="border-t border-[#eef5f3]" data-testid={`contact-clicks-row-${r.day}`}>
                  <td className="py-2 font-medium text-[#0f2e2a]">{fmt(r.day)}</td>
                  {COLS.map(([k]) => <td key={k} className="py-2 text-right font-semibold">{r[k]}</td>)}
                  <td className="hidden py-2 text-right text-[#5b6d6a] sm:table-cell">{r.visitors}</td>
                  <td className="hidden py-2 pl-4 sm:table-cell"><div className="flex h-2.5 overflow-hidden rounded-full bg-[#eef5f3]" style={{ width: `${(tot / max) * 100}%` }}>{COLS.map(([k, , c]) => <span key={k} style={{ width: `${tot ? (r[k] / tot) * 100 : 0}%`, background: c }} />)}</div></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-[12px] text-[#6b7c79]">Counts every tap on a WhatsApp, call or text button anywhere on your website (Eastern time days). Visitors = different people who tapped that day.</p>
    </div>
  );
};
